import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import PropTypes from "prop-types";
import { XIcon } from "@heroicons/react/outline";
import tw from "tailwind-styled-components";

const ModalWrapper = tw.div`
inline-block 
bg-white 
rounded-lg 
px-4 
pt-5 
pb-4 
text-left 
overflow-hidden 
shadow-xl 
transform 
transition-all 
my-8 
align-middle 
max-w-lg 
w-full 
p-6
`;

export default function Modal({ isOpened, focusElement, onClose, children }) {
  // (partial) Fix for transitions
  // TODO: transition is not played in cases the component is unmounted outside
  // e.g. on form submit

  const [opened, setOpened] = useState(false);

  const closeModal = useCallback(() => {
    setOpened(false);
    // then `onClose` will be called via `afterLeave`
  }, []);

  useEffect(() => {
    setOpened(isOpened);
  }, [isOpened]);

  return (
    <Transition show={opened} afterLeave={onClose}>
      <Dialog
        initialFocus={focusElement}
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={closeModal}
      >
        <div className="min-h-screen pt-4 px-4 pb-20 text-center block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block align-middle h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 translate-y-0 scale-95"
            enterTo="opacity-100 translate-y-0 scale-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100 translate-y-0 scale-100"
            leaveTo="opacity-0 translate-y-0 scale-95"
          >
            <ModalWrapper>
              <div className="block absolute -top-2 right-0 pt-4 pr-4">
                <button
                  className="pl-3 py-2 focus:outline-none"
                  type="button"
                  onClick={closeModal}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
              {children}
            </ModalWrapper>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

Modal.propTypes = {
  children: PropTypes.any.isRequired,
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  focusElement: PropTypes.any,
};
